import type { IconSvgObject } from './types';

const VolumeMute02Icon: IconSvgObject = [
  ["path", { d: "M18 10L22 14M18 14L22 10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 8.5H4C2.89543 8.5 2 9.39543 2 10.5V13.5C2 14.6046 2.89543 15.5 4 15.5H7L14 20V4L7 8.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default VolumeMute02Icon;
